module.exports = __webpack_public_path__ + "static/recordbook-12b875f3b56833750b4730309424be82.jpeg";